<script setup lang="ts">

import { CDN } from '@/models/cdn.ts'
import ModalTrigger from '@/components/Interface/Modal/ModalTrigger.vue'
import StyledImage from '@/components/Elements/Images/StyledImage.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
defineProps({
  buildingCode: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  }
});

</script>

<template>
  <div class="flex">
    <ModalTrigger type="building" :data="{'buildingCode': buildingCode}" class="flex-shrink-0">
      <StyledImage :src="CDN.building(128,buildingCode)" size="card" />
    </ModalTrigger>
    <div class="px-2">
      <div class="text-metal-300 pb-0.5">{{ t('research.buildingRequired') }}</div>
      <div class="text-subtext pt-1">{{ text }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>